module.exports = __webpack_public_path__ + "img/deviceCloud2.f9d2c126.jpg";